const SOURCE_HOST = 'nsfw.land';

const outboundConfig = () => window.toptechOutboundLinks || {};

const trackingParams = () => {
    if (outboundConfig().params) {
        return outboundConfig().params;
    }

    return {utm_source: SOURCE_HOST};
};

const internalHosts = () => {
    const configuredHosts = Array.isArray(outboundConfig().internalHosts)
        ? outboundConfig().internalHosts
        : [SOURCE_HOST];

    return [...configuredHosts, window.location.hostname]
        .map((host) => String(host).toLowerCase().replace(/^\.+|\.+$/g, ''))
        .filter(Boolean);
};

const isInternalHostname = (hostname) => internalHosts().some((internalHost) => (
    hostname === internalHost || hostname.endsWith(`.${internalHost}`)
));

const attributeOutboundLink = (link) => {
    if (!link.matches || !link.matches('a[href]')) {
        return;
    }

    const rawHref = link.getAttribute('href');

    if (!rawHref) {
        return;
    }

    let url;

    try {
        url = new URL(rawHref, window.location.href);
    } catch (error) {
        return;
    }

    if (!['http:', 'https:'].includes(url.protocol)) {
        return;
    }

    const hostname = url.hostname.toLowerCase().replace(/\.$/, '');

    if (isInternalHostname(hostname)) {
        return;
    }

    Object.entries(trackingParams()).forEach(([key, value]) => {
        if (key && value !== null && typeof value !== 'undefined' && String(value) !== '') {
            url.searchParams.set(key, String(value));
        }
    });
    const attributedHref = url.toString();

    if (rawHref !== attributedHref) {
        link.setAttribute('href', attributedHref);
    }
};

const attributeOutboundLinksIn = (root) => {
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) {
        return;
    }

    if (root.matches && root.matches('a[href]')) {
        attributeOutboundLink(root);
    }

    root.querySelectorAll('a[href]').forEach(attributeOutboundLink);
};

export const outboundLinks = () => {
    attributeOutboundLinksIn(document);

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes') {
                attributeOutboundLink(mutation.target);
                return;
            }

            mutation.addedNodes.forEach(attributeOutboundLinksIn);
        });
    });

    observer.observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['href'],
    });
};
